// Copyright (c) 2026 Or2 LLC. All rights reserved.
// Insight Platform - proprietary software by Nnaico (https://nnaico.com).
// See the LICENSE file in this repository. All rights reserved.

import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format a server timestamp in the viewer's local timezone (the equivalent
 * of Angular's date pipe). Accepts ISO strings with or without a UTC
 * offset; values without an offset are treated as local time. Pass opts
 * to customize (Intl.DateTimeFormat options), e.g. { dateStyle: 'long' }.
 */
export function formatDateTime(value, opts) {
  if (!value) return "";
  const d = new Date(value);
  if (isNaN(d.getTime())) return String(value);
  return d.toLocaleString(undefined, opts || { dateStyle: "medium", timeStyle: "short" });
}
